import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { LoginWidget } from './LoginWidget'

/**
 * <holdstyring-login> Web Component
 *
 * Displays login/register form for user authentication.
 *
 * Attributes:
 *   api-key: Required. Your Holdstyring API key.
 *   tenant-slug: Required on external sites.
 *   theme-*: Optional. See HoldstyringWidgetBase.observedAttributes.
 *
 * This widget has no attributes of its own — login and registration are always
 * both offered.
 *
 * Events (dispatched on window):
 *   holdstyring-widget-login: Fired when user logs in successfully (detail.user).
 *   holdstyring-widget-register: Fired when user registers successfully (detail.user).
 *   holdstyring-widget-logout: Fired when user logs out.
 *
 * Example:
 *   <holdstyring-login api-key="wk_live_xxx"></holdstyring-login>
 */
class HoldstyringLoginElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return LoginWidget
  }
}

// Register the custom element
if (!customElements.get('holdstyring-login')) {
  customElements.define('holdstyring-login', HoldstyringLoginElement)
}

export { HoldstyringLoginElement }
